/**
 * Российский телефон: маска +7 (XXX) XXX-XX-XX, хранение +7XXXXXXXXXX.
 * 8…, 7…, +7… приводятся к +7 и 10 национальным цифрам.
 */

/** 10 национальных цифр без кода страны */
export function parseNationalDigits(value) {
  const d = String(value || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 1 && (d[0] === "7" || d[0] === "8")) return "";
  if (d.length >= 11 && (d[0] === "7" || d[0] === "8")) {
    return d.slice(1, 11);
  }
  if ((d[0] === "7" || d[0] === "8") && d.length > 1) {
    return d.slice(1).slice(0, 10);
  }
  return d.slice(0, 10);
}

/** Канонический формат для API и БД: +7XXXXXXXXXX (или "" если цифр нет) */
export function normalizePhoneRu(value) {
  const national = parseNationalDigits(value);
  if (!national) return "";
  return `+7${national}`;
}

/** Полный номер (10 цифр) */
export function isPhoneComplete(value) {
  return parseNationalDigits(value).length === 10;
}

/** Маска для поля ввода */
export function formatPhoneDisplay(value) {
  const national = parseNationalDigits(value);
  if (!national) return "";
  if (national.length <= 3) return `+7 (${national}`;
  if (national.length <= 6) {
    return `+7 (${national.slice(0, 3)}) ${national.slice(3)}`;
  }
  return `+7 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 8)}-${national.slice(8, 10)}`;
}

/** @deprecated используйте parseNationalDigits */
export function parsePhoneInput(value) {
  const national = parseNationalDigits(value);
  if (!national) return "";
  return national.length === 10 ? `7${national}` : national;
}

/** @deprecated используйте parseNationalDigits */
export function getPhoneDigits(digitsOrFormatted) {
  return parseNationalDigits(digitsOrFormatted);
}

export function isPhoneLikeLoginInput(value) {
  const v = String(value || "").trim();
  if (!v) return true;
  if (v.includes("@")) return false;
  return /^[\d+\s()\-]*$/.test(v);
}

export function formatLoginIdentifier(value) {
  if (!isPhoneLikeLoginInput(value)) return value;
  return formatPhoneDisplay(value);
}

export function normalizeLoginIdentifier(value) {
  const v = String(value || "").trim();
  if (!v) return "";
  if (v.includes("@")) return v.toLowerCase();
  return normalizePhoneRu(v) || v.replace(/\s/g, "");
}
